var $6f40c3a58f594b58$exports = {};
console.log("hello world");


//# sourceMappingURL=test-parcel.b30b7da3.js.map
